<template>
  <a 
    class="anchor-link"
    :class="extraClasses"
    :href="href"
    @click.prevent="linkClicked"
    v-html="text"
  >
  </a>
</template>

<script>
import $ from 'jquery';
import animations from '../../lib/sk-animations';

export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    anchorId: {
      type: String,
      required: true,
    },
    extraClasses: {
      type: String,
      default: '',
    },
  },
  computed: {
    href(){
      return `#${this.anchorId}`;
    },
  },
  methods: {
    linkClicked(){
      animations.easedAnchorScroll(
        $(this.$el),
        $(this.href),
        100,
        150
      );
    },
  }
};
</script>